var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMartin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500.00001 500.00001",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -552.36)",
    fill: "none",
    stroke: "#555",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 38.966
  }, /*#__PURE__*/React.createElement("path", {
    d: "m125.28 700.91-101.56 101.56 101.56 101.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.97 700.91 101.56 101.56-101.56 101.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.86 670.23-54.621 265.77"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMartin);
export default __webpack_public_path__ + "static/media/martin.2a6d92fc5fc44ba45bb826c04ba95dd5.svg";
export { ForwardRef as ReactComponent };